import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../provider/AuthProvider';

import { useLocation, useNavigate } from 'react-router';
import gameAPI from '../../../../api/gameAPI';
import MasterPage from '../../../../layouts/MasterPage';
import PopupBox from '../../../../components/PopupBox';
import AuthenticationManager from '../../../../services/StorageJWT';
const tips = [
  'nameh',
  'compass',
  'coins',
  'stamp',
  'king',
  'cube',
  'fabric',
  'robe',
  'map',
];
const tipsIcon = [
  '/images/steps/1.png',
  '/images/steps/2.png',
  '/images/steps/3.png',
  '/images/steps/4.png',
  '/images/steps/5.png',
  '/images/steps/6.png',
  '/images/steps/7.png',
  '/images/steps/8.png',
  '/images/steps/9.png',
];
const Help = () => {
  const [showTitleAnswer, setShowTitleAnswer] = useState('');
  const [showTextAnswer, setShowTextAnswer] = useState('');
  const [confirm, setConfirm] = useState(0);
  const [guids, setGuids] = useState([]);
  const [userGuids, setUserGuids] = useState([]);
  const [typeFa, setTypeFa] = useState();
  const [styleButton, setStyleButton] = useState([null, null, null, null]);
  const [activeTip, setActiveTip] = useState(-1);
  const [errorText, setErrorText] = useState('');
  const [show, setShow] = useState(false);
  const { token } = useAuth();
  const auth = new AuthenticationManager();
  const navigate = useNavigate();
  let statePrev = useLocation();
  const setType = (type) => {
    switch (type) {
      case 'nameh':
        setTypeFa('نامه');
        break;
    }
  };
  const init = () => {
    setShowTitleAnswer('');
    setShowTextAnswer('');
    setConfirm(0);
    setActiveTip(-1);
    setErrorText('');
    setShow(false);
    setStyleButton([null, null, null, null]);
  };
  useEffect(() => {
    init();
    gameAPI.help(statePrev.state.type, token).then((res) => {
      setGuids(res.guids);
      setUserGuids(res.user_guids);
    });
    setType(statePrev.state.type);
  }, [statePrev]);

  const checkExistBefore = (tip) => {
    var _status = false;
    userGuids.map((guid) => {
      if (guid.tip == tip) {
        setShowTextAnswer(guid.answer);
        setShowTitleAnswer(guid.title);
        _status = true;
      }
    });
    return _status;
  };
  const showAnswer = (index, guid) => {
    var _styleButton = styleButton;

    for (var i = 0; i < _styleButton.length; i++) {
      if (i == index) _styleButton[i] = 'border-danger';
      else _styleButton[i] = null;
    }
    setStyleButton(_styleButton);
    setActiveTip(index);

    if (checkExistBefore(guid.tip) == true) {
      setConfirm(2);
    } else {
      setShowTitleAnswer(guid.title);
      setConfirm(1);
    }
  };
  const getAnswer = () => {
    gameAPI
      .getAnswer(guids[activeTip].id, token)
      .then((res) => {
        setShowTitleAnswer(res.guid.title);
        setShowTextAnswer(res.guid.answer);
        setConfirm(2);
        setUserGuids([...userGuids, { ...res.guid }]);
        if(res?.point)
          auth.updatePoint(res.point);
      })
      .catch((e) => {
        if (e?.response?.status == 422) {
          setShow(true);
          setErrorText('امتیاز شما کافی نمی باشد');
        }

        console.log(e);
      });
  };
  const styleTextCheck = (tip, index) => {
    var style = '';
    userGuids.map((guid) => {
      if (guid.tip == tip && index == activeTip) style = 'text-danger';
      else if (guid.tip == tip) style = 'text-gray';
    });
    return style;
  };
  const stylePointCheck = (tip, index) => {
    var style = '';
    userGuids.map((guid) => {
      if (guid.tip == tip) style = 'd-none';
    });
    return style;
  };
  const backTip = () => {
    // alert(statePrev.state.type)
    var res = tips.indexOf(statePrev.state.type);
    navigate('/one/helps', { state: { type: tips[res - 1] } });
  };
  const nextTip = (tip) => {
    var res = tips.indexOf(statePrev.state.type);

    navigate('/one/helps', { state: { type: tips[res + 1] } });
  };
  return (
    <MasterPage>
      <div className="">
        <div className="structure-page login p-3 body   ">
          <div className="helps">
            <div
              className={`d-grid text-center answer ${
                confirm == 0 ? 'invisible' : null
              }`}
            >
              {confirm === 1 && <h4 className="fw-bold"> {showTitleAnswer}</h4>}
              {confirm === 1 && (
                <div>از مشاهده این راهنمایی اطمینان دارید؟</div>
              )}
              {confirm === 1 && (
                <div className="d-flex gap-1">
                  <button
                    className="btn btn-show pt-2 pb-2 mb-4"
                    onClick={getAnswer}
                  >
                    مشاهده
                  </button>
                  <button
                    onClick={() => setConfirm(-1)}
                    className="btn btn-cancel pt-2 pb-2 mb-4"
                  >
                    انصراف
                  </button>
                </div>
              )}
              {confirm === 2 && (
                <div>
                  <h4>{showTitleAnswer}</h4>
                <div className='hint-text'  dangerouslySetInnerHTML={{__html: showTextAnswer}}></div>  
                </div>
              )}
            </div>

            <div className="options">
              <div className="d-flex align-items-center overflow-hidden ">
                <img
                  role="button"
                  onClick={nextTip}
                  src="/icons/arrow-right.svg"
                  className={`${
                    tips.indexOf(statePrev.state.type) !== tips.length - 1
                      ? null
                      : 'invisible'
                  }`}
                />

                <img
                  src={tipsIcon[tips.indexOf(statePrev.state.type)]}
                  style={{ height: 100 }}
                  className=" m-auto mb-2 "
                />
                <img
                  role="button"
                  onClick={backTip}
                  src="/icons/arrow-left.svg"
                  className={`${
                    tips.indexOf(statePrev.state.type) !== 0
                      ? null
                      : 'invisible'
                  }`}
                />
              </div>
              {guids.map((guid, index) => (
                <div
                  key={guid.id}
                  className={`help-button ${styleButton[index]}`}
                  role="button"
                  onClick={() => showAnswer(index, guid)}
                >
                  <span
                    className={`text-danger point-tip ${stylePointCheck(
                      guid.tip,
                      index
                    )}`}
                  >
                    {guid.point}-
                  </span>
                  <span
                    className={`fw-bold ps-1 ${styleTextCheck(
                      guid.tip,
                      index
                    )}`}
                  >
                    {guid.title}
                  </span>
                </div>
              ))}
            </div>
            <PopupBox show={show} setShow={setShow} text={errorText} />
          </div>
          <button
            onClick={() => navigate('/one')}
            className="btn btn-return pt-2 pb-2 mb-4"
          >
            بازگـشـت
          </button>
        </div>
      </div>
    </MasterPage>
  );
};

export default Help;
